import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AvanoUnsavedChangesSupport } from './avano-unsaved-changes.common';
import { AvanoUnsavedChangesService } from './avano-unsaved-changes.service';

@Injectable({
  providedIn: 'root'
})
export class AvanoUnsavedChangesGuard implements CanDeactivate<unknown> {
  constructor(private avanoUnsavedChangesService: AvanoUnsavedChangesService) {}
  canDeactivate(component: AvanoUnsavedChangesSupport): boolean | Observable<boolean> {
    const dirtyComponents = this.avanoUnsavedChangesService.getDirtyComponents();
    if (dirtyComponents.length > 0) {
      return this.avanoUnsavedChangesService.promptDirtyComponentsActions(dirtyComponents).pipe(tap(canLeave => {
        if (canLeave) {
          this.avanoUnsavedChangesService.clearRegistry();
        }
      }))
    } else {
      return true;
    }
  }
}
